var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVisaIcon = function SvgVisaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 15,
    rx: 2,
    fill: "#fff",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.358 10.839H5.965L4.92 6.795c-.05-.186-.155-.35-.31-.428a4.49 4.49 0 0 0-1.277-.428v-.156h2.245c.31 0 .542.234.58.506l.543 2.917 1.393-3.423h1.354l-2.09 5.056Zm2.865 0H8.907L9.99 5.783h1.316l-1.083 5.056Zm2.786-3.655c.038-.272.27-.428.542-.428.426-.04.89.039 1.277.233l.232-1.088a3.29 3.29 0 0 0-1.2-.234c-1.277 0-2.206.7-2.206 1.672 0 .74.658 1.127 1.123 1.361.503.233.696.39.658.622 0 .35-.388.506-.774.506a3.28 3.28 0 0 1-1.355-.312l-.232 1.09c.465.194.967.272 1.432.272 1.432.038 2.322-.661 2.322-1.711 0-1.323-1.82-1.4-1.82-1.983Zm6.424 3.655L18.39 5.783h-1.123a.583.583 0 0 0-.542.39l-1.935 4.666h1.355l.27-.739h1.665l.155.739h1.2ZM17.46 7.145l.386 1.905h-1.083l.697-1.905Z",
    fill: "#172B85"
  })));
};

export default SvgVisaIcon;